import { IReservationData } from 'core-lib';

const RESERVATION_UDF_GROUP = 'ReservationUDF';
const RESERVATION_CONFIRMATION_TYPE_UDF_KEY = 'ReservationConfirmationType';
const RESERVATION_CONFIRMATION_TYPE_TABLE = 'Table';
const EVENT_SITE_NAME_UDF_KEY = 'EventSiteName';
const TIME_BASED_EVENT_NAME_UDF_KEY = 'TimeBasedEventName';

export function getReservationUdfValue(reservation: IReservationData, key: string): string | undefined {
  return reservation.userDefinedFields?.find((item: any) =>
    item.group === RESERVATION_UDF_GROUP && item.key === key
  )?.value;
}

export function isTableReservation(reservation: IReservationData): boolean {
  return getReservationUdfValue(reservation, RESERVATION_CONFIRMATION_TYPE_UDF_KEY) === RESERVATION_CONFIRMATION_TYPE_TABLE;
}

export function getEventSiteName(reservation: IReservationData): string | undefined {
  return getReservationUdfValue(reservation, EVENT_SITE_NAME_UDF_KEY);
}

export function getTimeBasedEventName(reservation: IReservationData): string | undefined {
  return getReservationUdfValue(reservation, TIME_BASED_EVENT_NAME_UDF_KEY);
}
